// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"7a883ed0","162":"199d2a43","189":"3f86ee04","531":"8de99282","622":"101ea3f8","650":"78ba9b53","748":"dbc2e2ca","873":"d818382f"}[chunkId] + ".chunk.js";
};